// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___MMG29","panel":"panel___3LaHF"};